/**
 * Equity research published notes: DataTable + filter selects.
 * Runs only when #researchCoverageFilters is present (Equity Research - Published Notes listing).
 */
(function ($) {
    'use strict';

    function initResearchCoverageDataTable() {
        if (!$('#researchCoverageFilters').length) {
            return;
        }

        var $tableWrapper = $('.research-coverage-datatable--initializing');
        var $companySelect = $('#researchCoverageFilterCompany');
        var $industrySelect = $('#researchCoverageFilterIndustry');
        var $analystSelect = $('#researchCoverageFilterAnalyst');
        var $clearBtn = $('#researchCoverageClearFilters');

        var $table = $('.research-coverage-datatable--table').first();
        if (!$table.length) {
            return;
        }

        // Avoid "Cannot reinitialise DataTable" if this script or ready() runs twice (duplicate <script>, etc.).
        if (typeof DataTable !== 'undefined' && DataTable.isDataTable($table[0])) {
            return;
        }

        function showTable() {
            $tableWrapper.removeClass('research-coverage-datatable--initializing').addClass('research-coverage-datatable--initialized');
        }

        var dt = $table.DataTable({
            pageLength: 10,
            searching: true,
            ordering: false,
            lengthChange: false,
            layout: {
                topStart: null,
                topEnd: null,
                bottomEnd: {
                    paging: { firstLast: false }
                }
            }
        });

        $('div[id^="DataTables_Table_"]').addClass('overflow-table');

        function applyFilters() {
            var companyVal = $companySelect.val() || '';
            var industryVal = $industrySelect.val() || '';
            var analystVal = $analystSelect.val() || '';
            // Column search: use regex=false so symbols like & and () in labels are literal.
            dt.column(0).search(companyVal, false, false, true);
            dt.column(2).search(industryVal, false, false, true);
            dt.column(3).search(analystVal, false, false, true);
            dt.draw();
        }

        function clearFilters() {
            $companySelect.val('');
            $industrySelect.val('');
            $analystSelect.val('');
            applyFilters();
        }

        $(document).on('change', '#researchCoverageFilterCompany, #researchCoverageFilterIndustry, #researchCoverageFilterAnalyst', applyFilters);
        $clearBtn.on('click', clearFilters);

        showTable();
    }

    $(function () {
        initResearchCoverageDataTable();
    });
})(jQuery);
